import { useAuth } from './AuthProvider'
import { Navigate } from 'react-router-dom'
import { LoadingSpinner } from '../shared/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
  redirectTo?: string
}

export function ProtectedRoute({ children, redirectTo = '/session-timeout' }: ProtectedRouteProps) {
  const { isSignedIn, loading, user } = useAuth()

  // console.log('ProtectedRoute: Checking auth state', { isSignedIn, loading, user: !!user })

  if (loading) {
    console.log('ProtectedRoute: Loading, showing spinner')
    return <LoadingSpinner fullScreen size="xl" variant="minimal" />
  }

  if (!isSignedIn || !user) {
    console.log('ProtectedRoute: Not signed in or no user, redirecting to', redirectTo)
    return <Navigate to={redirectTo} replace />
  }

  console.log('ProtectedRoute: Signed in, rendering children')
  return <>{children}</>
}
